export default {
  Returns: 'Returns',
  ReturnDetails: 'ReturnDetails',
  CancelReturn: 'CancelReturn',
  ReturnsRoot: 'ReturnsRoot',
  CreateReturn: 'CreateReturn',
  ReturnOrderEditTracking: 'ReturnOrderEditTracking',
  AddItemsToReturn: 'AddItemsToReturn'
}
